module.exports = __webpack_public_path__ + "img/ico-down-arrow.011212ac.svg";